module.exports = __webpack_public_path__ + "8143c30ceb0f52a784a33f8cf0c2b8b5.MP3";